import { LitElement, PropertyValues, css, html, nothing } from "lit";
import { classMap } from "lit/directives/class-map.js";
import { customElement, property, state } from "lit/decorators.js";

import "@shoelace-style/shoelace/dist/components/menu/menu.js";
import "@shoelace-style/shoelace/dist/components/menu-label/menu-label.js";
import "@shoelace-style/shoelace/dist/components/menu-item/menu-item.js";
import "@shoelace-style/shoelace/dist/components/divider/divider.js";

import "@shoelace-style/shoelace/dist/themes/dark.styles.js";
import "@shoelace-style/shoelace/dist/themes/light.styles.js";

import { type MatchInput } from "..";
import { InputMenuItemState, iconTemplate, sortItems } from "./insert-menu";

@customElement("c-node-insert-submenu")
export class SubMenu extends LitElement {
    @property()
    item: InputMenuItemState;

    @property()
    input: MatchInput;

    @state()
    private subItems: InputMenuItemState["items"];

    @state()
    selection: number = 0;

    private get currentItem() {
        return this.subItems[this.selection];
    }

    down() {
        this.selection = (this.selection + 1) % this.subItems.length;
    }

    up() {
        this.selection = this.selection - 1;
        if (this.selection < 0) {
            this.selection = this.subItems.length - 1;
        }
    }

    runSelection(event: Event) {
        this.currentItem.run(event, this.input);
    }

    async willUpdate(changedProperties: PropertyValues<this>) {
        if (changedProperties.has("item")) {
            if (this.item?.getItems) {
                this.subItems = sortItems(await this.item.getItems());
            } else if (this.item?.items) {
                this.subItems = sortItems(this.item.items);
            } else {
                this.subItems = [];
            }
        }
    }

    render() {
        return html`<sl-menu>
            ${this.subItems
                ? this.subItems.map(
                      (menuItem, index) => html`
                          <sl-menu-item
                              ?disabled=${menuItem.disabled}
                              @mouseenter=${() => {
                                  this.selection = index;
                              }}
                              @focus=${() => {
                                  this.selection = index;
                              }}
                              @click=${(e: MouseEvent) => {
                                  if (menuItem.run) {
                                      menuItem.run(e, this.input);
                                  }
                              }}
                              class=${classMap({
                                  selected: index === this.selection,
                              })}
                              title=${menuItem.label}
                          >
                              ${menuItem?.icon
                                  ? iconTemplate({
                                        ...menuItem.icon,
                                        slot: "prefix",
                                    })
                                  : nothing}
                              ${menuItem?.label || ""}
                          </sl-menu-item>
                      `
                  )
                : html`<div>Loading...</div>`}
        </sl-menu>`;
    }

    static styles = css`
        .selected:not([disabled])::part(base) {
            background: var(--stekz-secondary-background);
            color: var(--text-color);
        }

        .selected[disabled]::part(base) {
            background-color: var(--sl-color-neutral-100);
            color: var(--text-color);
        }
    `;
}
